import { useSelector } from "react-redux";

const usePermittedRoute = () => {
  const selector = useSelector(
    (state) => state.permitModule.permittedModuleList
  );

  const checkPermittedRoute = ( checkingPath = "" ) => {
    const searchModule = checkingPath.toLowerCase();
    if (searchModule === "mis_report" || searchModule === "mis") {
      const isBrsrAllowed = selector.some(
        (listItem) =>
          listItem.module_name.trim().toLowerCase() === "brsr" &&
          listItem.status !== 0
      );
      if (isBrsrAllowed) return true;
    }
    if (searchModule === "observation" || searchModule === "observation_dashboard") {
      const isAllowed = selector.some((listItem) => {
        const name = listItem.module_name.trim().toLowerCase();
        return (
          (name === "observation" ||
            name === "observation_dashboard" ||
            name === "compliance_form") &&
          listItem.status !== 0
        );
      });
      if (isAllowed) return true;
    }
    // "scsurvey" is the backend's module_name for the survey module.
    if (searchModule === "survey" || searchModule === "scsurvey") {
      const isAllowed = selector.some((listItem) => {
        const name = listItem.module_name.trim().toLowerCase();
        return name === "scsurvey" && listItem.status !== 0;
      });
      return isAllowed;
    }
    const find = selector.find(
      (listItem) =>
        listItem.module_name.trim().toLowerCase() == searchModule &&
        listItem.status !== 0
    );
    return find == undefined ? false : true;
  }
  return [checkPermittedRoute];
};

export default usePermittedRoute;